import type { FaireProductEntity } from "../../entity_types/product";

export const p_vtmrk6wy57: FaireProductEntity = {
  token: "p_vtmrk6wy57",
  type: "product",
  name: "Juniper Highball / Water Glass / Set of 2",
  brandToken: "b_dtfc7uc37e",
  brandName: "Aaron Probyn US",
  imageUrl:
    "https://cdn.faire.com/fastly/831add7b1713b95ff70ccd291fb9323aa9f4bf55778aa2905a650e3f37e6eb52.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1a51942364731e7828af56aa7f575813efe7144d4d0914601a2fd6f579ca355c.jpeg",
  ],
  priceDollars: 17.5,
  description:
    'Juniper is a sculptural glassware range designed to elevate the drinking experience by enhancing both flavour and aroma. The glasses are graphic in form yet functional and satisfying to use, and their striking geometric silhouette adds interest to any table, bar or drinks trolley.\n\nJuniper Highball / Water Glass\n• Dimension: Ø 8.5cm x H 10.5cm / Ø 3.3" x H 4.1"\n• Capacity: 380ml / 13 fl oz\n\n• Packed as a set of 2\n\n• Colour: clear',
  tags: [],
  msrpDollars: 35,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-05-04T23:53:21.960Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
